import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import resetPasswordMail from "@main/customers/services/resetPasswordMail";
import {useContext} from "react";
import {ResetPasswordActionContext} from "@main/customers/actions/reset-password-mail/ResetPasswordActionContext";

function useResetPasswordMail() {
  const { email } = useContext(ResetPasswordActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
      resetPasswordMail({email: email}, onSuccess, errorHandler)
  };
}

export default useResetPasswordMail;
